// @ts-expect-error Untyped import
import { EVENTS } from '../../lib/usageTracker';
// @ts-expect-error Untyped import
import { trackEvent } from '../../lib/usageTracker';
import { useDispatch, useSelector } from 'react-redux';
// @ts-expect-error Untyped import
import { ROW_LIMITS } from '../../constants/rowLimits';
import { Flex } from 'foundations-components/components/Flex';
// @ts-expect-error Untyped import
import { selectFilters } from '../../selectors/reportsSelector';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error Untyped import
import { setReportsFilters } from '../../actions/reportsActions';
// @ts-expect-error Untyped import
import { selectReportCount } from '../../selectors/reportsSelector';
import { List } from 'foundations-components/transitional/components/List';
import { Button } from 'foundations-components/transitional/components/Button';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ReportsPaginator = () => {
  const dispatch = useDispatch();
  const reportCount = useSelector(selectReportCount);
  const filters = useSelector(selectFilters).toJS();
  const {
    offset,
    limit
  } = filters;
  const pageCount = Math.ceil(reportCount / limit);
  const handlePageChange = ({
    target: {
      value: pageNumber
    }
  }) => {
    trackEvent(EVENTS.changePage, {
      pageNumber
    });
    dispatch(setReportsFilters(Object.assign({}, filters, {
      offset: (pageNumber - 1) * limit
    })));
  };
  const handleLimitChange = updatedLimit => dispatch(setReportsFilters(Object.assign({}, filters, {
    limit: updatedLimit,
    offset: 0
  })));
  return /*#__PURE__*/_jsxs(Flex, {
    justifyContent: "center",
    alignItems: "baseline",
    children: [/*#__PURE__*/_jsx(Paginator, {
      onPageChange: handlePageChange,
      page: Math.floor(offset / limit) + 1,
      pageCount: pageCount
    }), /*#__PURE__*/_jsx(Dropdown, {
      buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reports.paginator.perPage",
        options: {
          count: limit
        }
      }),
      buttonUse: "transparent",
      children: /*#__PURE__*/_jsx(List, {
        wrapChildren: true,
        children: Object.values(ROW_LIMITS).map(rowLimit => /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: () => handleLimitChange(rowLimit),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "reports.paginator.perPage",
            options: {
              count: rowLimit
            }
          })
        }, rowLimit))
      })
    })]
  });
};